









import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { debounce } from '@/utils/helpers/helpFunctions'
import CalculatorControl from '@/components/modules/App/CalculatorComponent/CalculatorControl.vue'
import CalculatorPlug from '@/components/modules/App/CalculatorComponent/CalculatorPlug.vue'

interface Data {
  sizeFlag: boolean
  activateFlag: boolean
}

interface Methods {
  setSizeFlag: () => void
  setActivateFlag: (flag: boolean) => void
}

interface Computed {
  displayComponent: string
}

interface Props {}

export default Vue.extend({
  name: 'CalculatorComponent',
  components: {
    CalculatorControl,
    CalculatorPlug
  },
  data () {
    return {
      sizeFlag: false,
      activateFlag: true
    }
  },
  computed: {
    displayComponent () {
      return this.activateFlag && this.sizeFlag ? 'CalculatorPlug' : 'CalculatorControl'
    }
  },
  mounted () {
    this.setSizeFlag()
    window.addEventListener('resize', this.setSizeFlag)
  },
  methods: {
    setSizeFlag () {
      debounce(() => {
        this.sizeFlag = window.screen.width <= 767
      }, 200)
    },
    setActivateFlag (flag: boolean) {
      this.activateFlag = flag
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
